module.exports = __webpack_public_path__ + "static/img/solid-biofuel_256.ddf393c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solid-biofuel_256.png
// module id = iO/X
// module chunks = 0